
export type GetTrendingHashtagsParams = {
limit?: number;
};
